import { render, staticRenderFns } from "./SummaryHomeworkCard.vue?vue&type=template&id=5e8e0974&scoped=true"
import script from "./SummaryHomeworkCard.vue?vue&type=script&lang=ts"
export * from "./SummaryHomeworkCard.vue?vue&type=script&lang=ts"
import style0 from "./SummaryHomeworkCard.vue?vue&type=style&index=0&id=5e8e0974&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e8e0974",
  null
  
)

export default component.exports